import { Button, Typography } from '@ghq-abi/design-system-v2';

import { Card } from '~/shared/components';
import { BaseBadge } from '~/shared/components/Badges/BaseBadge';

import { HomeActionCardProps } from '../types';

export function ActionCard({
  title,
  description,
  actionLabel,
  onAction,
  descriptionTitle,
  badge
}: HomeActionCardProps) {
  return (
    <Card.Root className="flex h-full flex-col">
      <Card.Header
        className="items-center"
        actionButton={
          badge ? (
            <BaseBadge label={badge.label} variant={badge.variant} />
          ) : undefined
        }>
        {title}
      </Card.Header>

      <Card.Content className="flex flex-1 flex-col py-4">
        {descriptionTitle && (
          <Typography as="p" className="mb-2" variant="body-md-bold">
            {descriptionTitle}
          </Typography>
        )}
        <Typography as="p" variant="body-md-regular">
          {description}
        </Typography>
      </Card.Content>

      <Card.Footer className="mt-auto border-t-0 pt-0">
        <Button
          border="default"
          size="md"
          type="button"
          variant="secondary"
          onClick={onAction}>
          {actionLabel}
        </Button>
      </Card.Footer>
    </Card.Root>
  );
}
